<template>
  <div class="flex flex-wrap gap-y-3">
    <Field :rules="requiredRule" name="currentUsername" v-slot="{ field, errors: errs }">
      <TextInput
        :field="field"
        :errors="errs"
        :label="$t('currentUsername')"
        :max-length=" 60"
        class="w-full"
        label-class="w-full"
        direction="flex-col"
      >
      </TextInput>
    </Field>
   
  </div>
</template>

<script setup>
import TextInput from '@/components/SimpleForm/TextInput.vue'
import { Field } from 'vee-validate'
import { reactive } from 'vue'
import { useI18n } from 'vue-i18n'

const i18n = useI18n()

function requiredRule(value) {
  if (!value || !`${value}`.trim()) {
    return i18n.t('INVALID_REQUIRED')
  }

  return true
}
</script>

<style lang="scss" scoped></style>
